


















import { Component } from 'vue-property-decorator';
import ClientDetail from '@/components/ClientDetail.vue';
// import { KCardHeader, FormPage }	from '@kasasa/fbase-components';
import { KCardHeader } from '@kasasa/fbase-components';
import FormPage from '@/components/FormPage.vue';

@Component({
	components: {
		ClientDetail,
		KCardHeader
	}
})
export default class AddClietView extends FormPage {

	title ='Add New Client';
	get items(): Array<Record<string, unknown>> {
		return [
			{
				text: 'Clients',
				disabled: false,
				link: true,
				exact: true,
				to: { name: 'Home' },
			},
			{
				text: this.title,
				disabled: true,
			}
		];
	}
}
